import PropTypes, { func } from 'prop-types';
import React from 'react';
import {
  CreateManuallyAction,
  CreateWithWebsiteDialogue,
  UploadBrandGuideDialogue,
} from './dialogues';
import { getActionsCardsStyles } from './styles';

const BrandActionCards = ({ i18n }) => {
  const classes = getActionsCardsStyles();

  const [
    isBrandKitCreationInProgress,
    setIsBrandKitCreationInProgress,
  ] = React.useState(false);

  const handleBrandKitCreation = (brandKitCreationPayload) => {
    console.log(brandKitCreationPayload);
    setIsBrandKitCreationInProgress(true);
  };

  return (
    <div className={classes.container}>
      <UploadBrandGuideDialogue
        i18n={i18n}
        onCreateBrandKit={handleBrandKitCreation}
        isBrandKitCreationInProgress={isBrandKitCreationInProgress}
      />
      <CreateWithWebsiteDialogue
        i18n={i18n}
        onCreateBrandKit={handleBrandKitCreation}
        isBrandKitCreationInProgress={isBrandKitCreationInProgress}
      />
      <CreateManuallyAction i18n={i18n} />
    </div>
  );
};

export { BrandActionCards };

BrandActionCards.propTypes = {
  i18n: PropTypes.shape({ getString: func }).isRequired,
};
